import React from 'react';
import { Tab1 } from './Tab1';
import { Tab2 } from './Tab2';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { UnknownAction } from '@reduxjs/toolkit';
import UpArrow from '../../../../assets/icons/UpArrow.svg';
import { TabPanel } from '../../../../shared/components/tabPanel/index';
import { ActivityFactorPALSelectType } from '../../../../shared/shared.interfaces';
import { CardWithInput } from '../../../../shared/components/halfCircleCardWithInput/index';

export const ActivityFactor = ({
  BMRVal,
  summary,
  activityFactor,
  activityFactorPAL_Input,
  activityFactorPAL_Select,
  setSummaryVal,
  setActivityFactor,
  setActivityFactorPAL_Input,
  setActivityFactorPAL_Select
}: {
  BMRVal: number;
  summary: number;
  activityFactorPAL_Select: ActivityFactorPALSelectType;
  activityFactor: { optionSelected: string; value: number };
  activityFactorPAL_Input: { PALRatio: number; value: number };
  setSummaryVal: (val: number) => UnknownAction;
  setActivityFactorPAL_Select: (
    val: ActivityFactorPALSelectType
  ) => UnknownAction;
  setActivityFactorPAL_Input: (val: {
    PALRatio: number;
    value: number;
  }) => UnknownAction;
  setActivityFactor: (val: {
    optionSelected: string;
    value: number;
  }) => UnknownAction;
}) => {
  const dispatch = useDispatch();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2.5rem',
        marginTop: '1.875rem',
        marginBottom: '1.875rem'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          backgroundColor: '#fff',
          borderRadius: '0.9375rem'
        }}
      >
        <TabPanel
          tabs={['Activity Factor', 'PAL']}
          panelData={[
            <Tab1
              key={0}
              BMRVal={BMRVal}
              activityFactor={activityFactor}
              setActivityFactor={setActivityFactor}
            />,
            <Tab2
              key={1}
              BMRVal={BMRVal}
              activityFactorPAL_Input={activityFactorPAL_Input}
              activityFactorPAL_Select={activityFactorPAL_Select}
              setActivityFactorPAL_Input={setActivityFactorPAL_Input}
              setActivityFactorPAL_Select={setActivityFactorPAL_Select}
            />
          ]}
          styleType="type2"
        ></TabPanel>
      </Box>
      <CardWithInput
        label1="adjust for energy stores"
        label2="(Kcal)"
        icon={UpArrow}
        range={{ min: -100000, max: 100000 }}
        value={summary}
        setValue={(val: number) => {
          dispatch(setSummaryVal(val));
        }}
      />
    </Box>
  );
};
